import { app } from "../main.js";
// import { alert } from "devextreme/ui/dialog";

export function getSTRING(lang, id, def) {
    let stringValue = def;
    if (app.config.globalProperties.$strings != null) {
        app.config.globalProperties.$strings.forEach(element => {
            if (element.key.toLowerCase().trim() == (lang + "-" + id).toLowerCase().trim()) {
                stringValue = element.value
            }
        });
    }
    return stringValue
}

// export function showAlert(error,title){
//     if (!app.config.globalProperties.$GenericError)
//     {
//         app.config.globalProperties.$GenericError = true;
//         alert(error, title).then(()=>{
//             app.config.globalProperties.$GenericError = false;
//         })
        
//     }    
// }

